<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <zestawieniaMenu></zestawieniaMenu>
                <div class="widget-heading d-flex justify-content-between align-items-center">
                    <h4 class="my-0">Udziały w dyskach sieciowych</h4>
                    <div class="d-flex align-items-center gap-2">
                        <a :href="route('kadry.dyski.excel')" class="btn btn-success" download><i
                                class="bi bi-file-earmark-excel"></i>&nbsp;Pobierz do Excel</a>
                        <a :href="route('kadry.dyski.pdf')" class="btn btn-info" target="_blank"><i
                                class="bi bi-file-earmark-pdf"></i>&nbsp;Pobierz PDF </a>
                        <button class="btn btn-primary" @click="loadUsers" :disabled="loading"><i
                                class="bi bi-arrow-clockwise"></i> {{ loading ? 'Odświeżanie...' : 'Odśwież' }}</button>
                    </div>
                </div>
                <div class="widget-content">
                    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                    <div class="table-responsive w-100">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="bg-gray-100 text-start" style="min-width:200px;">Imię i nazwisko</th>
                                    <th class="bg-gray-100 text-start">Login UNIX</th>
                                    <th class="bg-gray-100">Grupy / przydziały</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="loading">
                                    <td colspan="3" class="text-center">Pobieranie danych...</td>
                                </tr>
                                <tr v-else-if="localUsers.length === 0">
                                    <td colspan="3" class="text-center text-muted">Brak użytkowników.</td>
                                </tr>
                                <tr v-for="user in localUsers" :key="user.login">
                                    <td class="text-start">
                                        <strong v-if="user.name">{{ user.name }}</strong>
                                        <span v-else class="text-muted">—</span>
                                    </td>
                                    <td class="text-start login">{{ user.login }}</td>
                                    <td>
                                        <template v-if="user.groups && user.groups.length">
                                            <span v-for="group in user.groups" :key="`${user.login}-${group}`"
                                                class="group">
                                                <span class="group-name">{{ group }}</span>
                                            </span>
                                        </template>
                                        <span v-else class="text-muted">Brak grup</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from "axios";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";

const { hasPermission } = usePermission();

export default {
    components: { AppLayout, hasPermission, zestawieniaMenu },
    props: {
        users: { type: Array, required: true },
        error: { type: String, default: null }
    },
    data() {
        return {
            localUsers: [],
            loading: false,
            errorMessage: this.error,
            hasPermission
        };
    },
    mounted() {
        this.localUsers = this.users.map(user => ({
            ...user,
            groups: Array.isArray(user.groups) ? [...user.groups] : []
        }));
    },
    methods: {
        async loadUsers() {
            this.loading = true;
            this.errorMessage = null;
            try {
                const response = await axios.get("/smb/users/data");
                if (response.data && response.data.success) {
                    this.localUsers = response.data.users.map(user => ({
                        ...user,
                        groups: Array.isArray(user.groups) ? [...user.groups] : []
                    }));
                } else {
                    throw new Error(response.data?.error || "Nie udało się pobrać użytkowników.");
                }
            } catch (error) {
                console.error(error);
                this.errorMessage = error.response?.data?.error || error.message || "Nie udało się pobrać danych z serwera SMB.";
                this.showToast("error", "Błąd", this.errorMessage);
            } finally {
                this.loading = false;
            }
        },
        showToast(icon, title, message) {
            Toast.fire({
                position: "top-end",
                toast: true,
                icon: icon,
                title: title,
                html: message,
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
                timer: 1500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        }
    }
};
</script>

<style scoped>
table th,
table td {
    min-width: 50px;
    height: 32px;
}

.bg-gray-100 {
    background-color: #f5f5f5;
    color: black;
}

.text-start {
    text-align: left;
}

.login {
    font-family: monospace;
    color: #555;
}

.group {
    display: inline-flex;
    background: #e9ecef;
    border-radius: 5px;
    margin: 3px;
    padding: 5px 5px 5px 9px;
}

.group-name {
    margin-right: 7px;
}
</style>